export default __webpack_public_path__ + "static/media/Fidget-spinner.29181c59.gif";